import React from 'react';
// ROUTER
import { Link } from 'react-router-dom';
// ANTD
import { Button } from 'antd';
// INTL
import { FormattedMessage } from 'react-intl';
import withTranslations from 'app/components/HOGs/withTranslations';
import { addToDownload } from '../../../Utility/utility';

const MainButton = (props) => {
  const { tr } = props;
  const { id = 0 } = props.placesData.data;

  const messageText = {
    tourAdded: tr['Already added to download'],
  };

  const clickBtnAddToDownload = (e) => {
    if (props.placesData.data !== 0) {
      addToDownload(
        e,
        props.downloadTourGps.data,
        props.placesData.data,
        props.openModalTourDownload,
        props.TourDownloadBasketData,
        props.TourDownloadCoord,
        messageText,
        'place'
      );
    } else {
      console.log('loading');
    }
  };
  const component = props.edit ? null : (
    <div className="mainButton">
      <Link to={`/createtour?place=${id}`}>
        <Button className="btn plan">
          <span>
            <FormattedMessage
              id="Add to Create tour"
              defaultMessage="Add to Create tour"
            />
          </span>
        </Button>
      </Link>
      <Button
        type="primary"
        className="btn download"
        onClick={(e) => clickBtnAddToDownload(e)}
      >
        <span>
          <FormattedMessage
            id="Add to download"
            defaultMessage="Add to download"
          />
        </span>
      </Button>
    </div>
  );
  return component;
};

export default withTranslations(MainButton);
